<script setup lang="ts">
    import { reactive } from 'vue';
    import { loginMethod } from './SignInAccess';
    import BankID from './BankID.vue';
    import BSFormInputText from '@shared/components/BSFormInputText.vue';

    import { getCookie } from '@cwd/lib/main';
    import SignedOut from '@cwd/Common/SignedOut.vue';
    import { redirectToReturnUrl } from './SignInRedirect';
    let userName = getCookie('Email');
    const state = reactive<{ userName: string | null }>({
        userName: userName || null,
    });

    function onLoginSuccessful() {
        redirectToReturnUrl();
    }
</script>
<script lang="ts">
    export default {
        components: { BankID },
        name: 'RegisterBankID',
    };
</script>
<template>
    <!-- Input only used for display purposes -->

    <BSFormInputText
        :modelValue="userName"
        :required="true"
        :disabled="true"
        :label="$Resources.Email"
        class="form-group"
        autocomplete="email"
        :placeholder="$Resources.SignInUsernamePlaceholder"></BSFormInputText>

    <div>
        <BankID :username="userName" :mode="'signin'" @login-successful="onLoginSuccessful"></BankID>
    </div>
</template>

<style scoped></style>

<style lang="less"></style>
